<template>
  <div>
    <b-card-code :title="'Subir csv traducciones'" v-if="!procesado">
      <b-row class="match-height justify-content-center">
        <b-col cols="12">
          <b-form-file
            v-model="csvInput"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          />
        </b-col>

        <b-col cols="1" style="margin-top: 10px">
          <b-button variant="outline-primary" @click="procesarCsvError">
            Procesar
          </b-button>
        </b-col>
        <b-col cols="12" style="text-align: center; margin-top: 10px">
          <p>Este proceso puede tardar...</p>
        </b-col>
      </b-row>
    </b-card-code>

    <b-card v-if="procesado">
      <b-button class="boton" @click="reset()">Reset</b-button>

      <div style="text-align: center; margin-top: 10px">
        <b-button
          v-if="!vistaValidos"
          variant="outline-danger"
          @click="vistaValidos = true"
          style="margin-right: 10px"
          >No Validos</b-button
        >
        <b-button
          v-if="vistaValidos"
          variant="outline-primary"
          @click="vistaValidos = false"
          >Validos
        </b-button>
      </div>

      <b-row style="margin-top: 20px">
        <b-col cols="4">
          <h3>
            Validos: {{ noRevisarCount }} | Total caracteres:
            {{ caracteresNoRevisarCount }}
          </h3>
          <h3>
            No validos {{ revisarCount }} | Total caracteres:
            {{ caracteresRevisarCount }}
          </h3>
        </b-col>
        <b-col md="2">
          <b-form-group label="Idioma*" label-for="v-country">
            <v-select
              id="v-country"
              v-model="idiomaSeleccionado"
              :options="idiomas"
              label="text"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4" style="text-align: center">
          <b-button v-if="!traducidos" variant="primary" @click="traducir()"
            >Traduccir</b-button
          >
        </b-col>
        <b-col cols="2">
          <b-button
            variant="secondary"
            @click="downloadCsv()"
            style="float: right"
            ><i class="fa-solid fa-download"></i
          ></b-button>
        </b-col>
      </b-row>

      <div v-if="vistaValidos">
        <b-row v-for="(item, index) in resValidos" :key="index">
          <b-col cols="6" class="text-area-translate">
            <b-form-textarea
              id="textarea"
              v-model="item.text"
              placeholder="Enter something..."
              rows="3"
              max-rows="6"
              readonly
            ></b-form-textarea>
          </b-col>

          <b-col cols="6" class="text-area-translate">
            <b-form-textarea
              id="textarea2"
              v-model="item.traduccion"
              placeholder="Enter something..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
            <b-button
              variant="primary"
              @click="copiarInformacion(item)"
              style="margin-left: -50px"
              ><i class="fa-solid fa-arrow-right"></i></b-button>
          </b-col>
        </b-row>
      </div>
      <div v-if="!vistaValidos">
        <b-row v-for="(item, index) in resNoValidos" :key="index">
          <b-col cols="6" class="text-area-translate">
            <b-form-textarea
              id="textarea"
              v-model="item.text"
              placeholder="Enter something..."
              rows="3"
              max-rows="6"
              readonly
            ></b-form-textarea>
          </b-col>
          <b-col cols="6" class="text-area-translate">
            <b-form-textarea
              id="textarea2"
              v-model="item.traduccion"
              placeholder="Enter something..."
              rows="3"
              max-rows="10"
            ></b-form-textarea>
            <b-button
              variant="primary"
              @click="traducirIndividual(item)"
              style="margin-left: -50px"
              ><i class="fa-solid fa-language"></i
            ></b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>    
    
  <script>
import vSelect from "vue-select";
import BCardCode from "@core/components/b-card-code";
import { BRow, BCol, BFormFile, BButton } from "bootstrap-vue";
import { BTable } from "bootstrap-vue";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import Papa from "papaparse";

export default {
  components: {
    BCardCode,
    BRow,
    BCol,
    BFormFile,
    BButton,
    vSelect,
    BTable,
  },

  data() {
    return {
      csvInput: [],
      resValidos: [],
      resNoValidos: [],
      revisarCount: 0,
      noRevisarCount: 0,
      caracteresRevisarCount: 0,
      caracteresNoRevisarCount: 0,
      vistaValidos: true,
      procesado: false,
      traducidos: false,
      idiomas: [
        { value: "ES", text: "Español" },
        { value: "FR", text: "Frances" },
        { value: "DE", text: "Aleman" },
        { value: "IT", text: "Italiano" },
      ],
      idiomaSeleccionado: "",
    };
  },
  methods: {
    reset() {
      this.csvInput = [];
      this.resValidos = [];
      this.resNoValidos = [];
      this.revisarCount = 0;
      this.noRevisarCount = 0;
      this.caracteresRevisarCount = 0;
      this.caracteresNoRevisarCount = 0;
      this.vistaValidos = true;
      this.procesado = false;
      this.traducidos = false;
    },
    traducir() {
      function toastShow(title, self) {
        self.$toast({
          component: ToastificationContent,
          props: {
            title: title,
            icon: "EditIcon",
            variant: "danger",
          },
        });
      }

      this.traducidos = true;

      if (this.idiomaSeleccionado == "") {
        toastShow("Selecciona un idioma", this);
        return;
      }

      if (this.vistaValidos) {
          const itemsSinTraduccion = this.resValidos.filter(item => item.traduccion === '');
          const textosEnviar = itemsSinTraduccion.map(item => item.text);

          axios.post("/options/traduccion", {
            textos: textosEnviar,
            idiomaDestino: this.idiomaSeleccionado.value,
          })
          .then(response => {
            const traducciones = response.data.traducciones;
            
            // Solo actualizamos los items que fueron enviados
            itemsSinTraduccion.forEach((item, index) => {
              item.traduccion = traducciones[index] || ''; // En caso de error de índice
            });
          })
          .catch(error => {
            console.error("Error al traducir:", error);
            // Aquí podrías mostrar una notificación visual si usas algo como Toast
          });
        }
    },
    copiarInformacion(item){
      item.traduccion = item.text;
      //console.log(item);
    },
    traducirIndividual(item) {
      if (this.idiomaSeleccionado == "") {
        toastShow("Selecciona un idioma", this);
        return;
      }
      axios
        .post("/options/traduccion", {
          textos: [item.text], // 👈 Array de textos
          idiomaDestino: this.idiomaSeleccionado.value, // O el idioma que necesites
        })
        .then((response) => {
          return response.data.traducciones; // 👈 Extraemos el array de traducciones
        })
        .then((traducciones) => {
          //console.log(traducciones);
          item.traduccion = traducciones[0];
        })
        .catch((error) => {
          console.error("Error al traducir:", error);
        });
    },
    procesarCsv() {
      this.procesado = true;

      this.resValidos = [];
      this.resNoValidos = [];
      this.revisarCount = 0;
      this.noRevisarCount = 0;
      this.caracteresRevisarCount = 0;
      this.caracteresNoRevisarCount = 0;

      function verificarCaracterEspecial(str) {
        // Eliminar las etiquetas HTML
        let textoPlano = "";
        let dentroDeEtiqueta = false;

        if (str.includes("shopify://") || str.includes(".jpg")) {
          return true;
        }

        for (let i = 0; i < str.length; i++) {
          if (str[i] === "<") {
            dentroDeEtiqueta = true;
          } else if (str[i] === ">") {
            dentroDeEtiqueta = false;
          } else if (!dentroDeEtiqueta) {
            textoPlano += str[i];
          }
        }

        // Comprobar los caracteres y si después de un carácter no permitido sigue una letra o número
        for (let i = 0; i < textoPlano.length - 1; i++) {
          const char = textoPlano[i];

          // Verificar si el carácter no es válido
          if (
            !(
              (char >= "a" && char <= "z") ||
              (char >= "A" && char <= "Z") ||
              (char >= "0" && char <= "9") ||
              char === " " ||
              char === "-" ||
              char === "/"
            )
          ) {
            //console.log(char);

            // Verificar si el siguiente carácter es una letra o número
            const siguienteChar = textoPlano[i + 1];
            if (
              (siguienteChar >= "a" && siguienteChar <= "z") ||
              (siguienteChar >= "A" && siguienteChar <= "Z") ||
              (siguienteChar >= "0" && siguienteChar <= "9")
            ) {
              return true; // Si hay un carácter no permitido seguido de una letra o número, devuelve true
            }
          }
        }

        return false; // Si no se encuentra ningún caso, devuelve false
      }

      var reader = new FileReader();
      var self = this;
      reader.onload = (e) => {
        let data = reader.result.split(/\r?\n/);

        let dataExport = [];

        data.forEach((line) => {
          // solo puede ser  - /
          // !

          //no puede haber un caracter a la izquerda de una letra o numero, solo admitir - /

          if (line != null && line != "source,target") {
            //console.log(object);
            let line2 = line.replace(/['"]+/g, "");

            if (line2[line2.length - 1] == ",")
              line2 = line2.substring(0, line2.length - 1);

            const newData = {
              text: line2,
              traduccion: "",
              revisar: verificarCaracterEspecial(line2),
            };

            if (newData.revisar) {
              self.caracteresRevisarCount += newData.text.length;
            } else self.caracteresNoRevisarCount += newData.text.length;

            dataExport.push(newData);
          }
        });

        //console.log(dataExport);

        this.revisarCount = dataExport.filter((item) => item.revisar).length;
        this.noRevisarCount = dataExport.filter((item) => !item.revisar).length;

        self.resNoValidos = dataExport.filter((item) => item.revisar);
        self.resValidos = dataExport.filter((item) => !item.revisar);
      };

      reader.readAsText(this.csvInput);
    },
    procesarCsvError() {
      this.procesado = true;

      this.resValidos = [];
      this.resNoValidos = [];
      this.revisarCount = 0;
      this.noRevisarCount = 0;
      this.caracteresRevisarCount = 0;
      this.caracteresNoRevisarCount = 0;

      function verificarCaracterEspecial2(str) {
        // Eliminar las etiquetas HTML
        let textoPlano = "";
        let dentroDeEtiqueta = false;

        if (str.includes("shopify://") || str.includes(".jpg")) {
          return true;
        }

        for (let i = 0; i < str.length; i++) {
          if (str[i] === "<") {
            dentroDeEtiqueta = true;
          } else if (str[i] === ">") {
            dentroDeEtiqueta = false;
          } else if (!dentroDeEtiqueta) {
            textoPlano += str[i];
          }
        }

        // Comprobar los caracteres y si después de un carácter no permitido sigue una letra o número
        for (let i = 0; i < textoPlano.length - 1; i++) {
          const char = textoPlano[i];

          // Verificar si el carácter no es válido
          if (
            !(
              (char >= "a" && char <= "z") ||
              (char >= "A" && char <= "Z") ||
              (char >= "0" && char <= "9") ||
              char === " " ||
              char === "-" ||
              char === "/"
            )
          ) {
            //console.log(char);

            // Verificar si el siguiente carácter es una letra o número
            const siguienteChar = textoPlano[i + 1];
            if (
              (siguienteChar >= "a" && siguienteChar <= "z") ||
              (siguienteChar >= "A" && siguienteChar <= "Z") ||
              (siguienteChar >= "0" && siguienteChar <= "9")
            ) {
              return true; // Si hay un carácter no permitido seguido de una letra o número, devuelve true
            }
          }
        }

        return false; // Si no se encuentra ningún caso, devuelve false
      }

      function verificarCaracterEspecial(str) {
        if (str.includes("shopify://") || str.includes(".jpg")) {
          return true;
        }
        return false;

        // Verificar si hay una letra seguida de un punto y otra letra
        const regex = /[a-zA-Z]\.[a-zA-Z]/;
        return regex.test(str);
      }

      var reader = new FileReader();
      var self = this;
      reader.onload = (e) => {
        // Suponiendo que reader.result tiene el contenido del archivo CSV
        let csvText = reader.result;

        // Usamos PapaParse para convertir el CSV a un array de objetos
        let parsedData = Papa.parse(csvText, {
          delimiter: ",", // Separador de columnas
          quoteChar: '"', // Maneja comillas dobles
          header: false, // No tiene encabezados
          skipEmptyLines: true,
        }).data;

        let dataExport = [];

        // Recorremos cada fila del CSV
        parsedData.forEach((row) => {

          //console.log(row);
          // Verificamos que la fila tenga al menos dos columnas
          if (
            row.length >= 2 &&
            !row[0].includes("shopify://") &&
            ((row[0].includes("https://") && row[0].includes(" ")) || !row[0].includes("https://")) &&
            !row[0].includes("&#") &&
            !row[0].includes("NEW!HB") &&
            row[0] != "source" &&
            row[0].toLowerCase() != "wallets" &&
            row[0].toLowerCase() != "sleeves" &&
            row[0].toLowerCase() != "bags" &&
            row[0].toLowerCase() != "new in" &&
            row[0].toLowerCase() != "gifts" &&
            row[0].toLowerCase() != "bestsellers" &&
            row[0].toLowerCase() != "discover"
          ) {
            const newData = {
              text: row[0],
              traduccion: row[1],
              revisar: verificarCaracterEspecial(row[0]),
            };

            dataExport.push(newData);

            if (newData.revisar) {
              self.caracteresRevisarCount += newData.text.length;
            } else self.caracteresNoRevisarCount += newData.text.length;
          }
        });

        this.revisarCount = dataExport.filter((item) => item.revisar).length;
        this.noRevisarCount = dataExport.filter((item) => !item.revisar).length;

        self.resNoValidos = dataExport.filter((item) => item.revisar);
        self.resValidos = dataExport.filter((item) => !item.revisar);

        const palabrasPermitidas = ["Accessories","Grey", "Black", "Mocha", "Stone","Olive","Brown","Beige","White","Pink","Red","Blue","Green","Yellow","Purple","Orange","Navy","Burgundy","Teal","Coral","Lavender","Habano","Khaki","Ocean"];

        self.resValidos.forEach((item) => {
            
            if (
              (item.text && !item.text.includes(' ') && item.text.includes('-') && /^[a-z0-9-]+$/.test(item.text)) ||
              palabrasPermitidas.includes(item.text)
            )
            {
              item.traduccion = item.text;
            }
        });

        //console.log(dataExport);
      };

      reader.readAsText(this.csvInput);
    },
    downloadCsv() {
      let csv = "source,target";
      /*console.log(this.resValidos);
      console.log(this.resNoValidos);*/
      this.resValidos.forEach((item) => {

         let traduccion = item.traduccion;

          traduccion = traduccion.replaceAll(/["]/g, '""');
          traduccion = item.traduccion.length > 0 ? `,"${traduccion}"` : ",";
          let textooriginal = item.text.replaceAll(/["]/g, '""');

          //console.log(textooriginal);

          csv += `\n"${textooriginal}"${traduccion}`;
      });

      //console.log(csv);

      this.resNoValidos.forEach((item) => {
        let traduccion = item.traduccion;

        traduccion = traduccion.replaceAll(/["]/g, '""');
        traduccion = item.traduccion.length > 0 ? `,"${traduccion}"` : ",";
        let textooriginal = item.text.replaceAll(/"/g, '""');
        //textooriginal = textooriginal.replaceAll(/”/g, '""');          

        csv += `\n"${textooriginal}"${traduccion}`;
      });

      this.downloadFile(csv, "traducciones_" + this.idiomaSeleccionado.value);
    },
    downloadFile(csv, name) {
      var encodedUri = encodeURIComponent(csv);
      var link = document.createElement("a");
      link.setAttribute("href", "data:text/csv;charset=utf-8," + encodedUri);
      link.setAttribute("download", name + ".csv");
      document.body.appendChild(link);
      link.click();
    },
  },
  mounted() {},
};
</script>

    <style lang="scss">
@import "../@core/scss/vue/libs/vue-select.scss";

.button_ejemplos {
  text-align: center;
  width: 100px;
  border: 1px solid black;
  border-radius: 10px;
  padding: 5px;
  margin-bottom: 10px;
  color: black;
  margin-top: 10px;
}

.button_ejemplos:hover {
  cursor: pointer;
}

.button_plantilla {
  margin-bottom: 0px;
}

.button_plantilla:hover {
  cursor: pointer;
}

.text-area-translate {
  padding: 20px;
}

.contenedor {
  position: relative;
  width: 200px;
  height: 100px;
  border: 1px solid #ccc;
  padding: 10px;
}

.boton {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 5px 10px;
  background-color: blue;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.boton:hover {
  background-color: darkblue;
}
</style>